import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {PushSubscribersState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: PushSubscribersState = {
    pushSubscribers: []
};


export const pushSubscriber: Module<PushSubscribersState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
